const TopMenu = {
  recycleBinProjects: [
    {
      text: "Recycle Bin",
      link: "pms/recycle-bin",
    },
  ],
  inactiveProjects: [
    {
      text: "Inactive Projects",
      link: "pms/inactive-projects",
    },
  ],
  archivedProjects: [
    {
      text: "Archived Projects",
      link: "pms/archived-projects",
    },
  ],
  closedProjects: [
    {
      text: "Closed Projects",
      link: "pms/closed-projects",
    },
  ],
  draftProjects: [
    {
      text: "Draft Projects",
      link: "pms/draftProjects",
    },
  ],
  ChecklistList: [
    {
      text: "Checklist Lists",
      link: "pms/Checklist/checklist-lists",
    },
  ],
  activeProjects: [
    {
      text: "Dashboard",
      link: "pms/main-dashboard",
    },
    {
      text: "Active Projects",
      link: "pms/active-projects",
    },
    {
      text: "Groups",
      link: "pms/groups-projects",
    },
    {
      text: "Pending Approvals",
      link: "pms/pending-approvals",
    },
    {
      text: "Rate Cards",
      link: "pms/rate-cards",
    },
    {
      text: "Norms",
      subMenu: [
        {
          text: "Material",
          link: "pms/norms",
        },
        {
          text: "Manpower",
          link: "pms/manpower-norms",
        },
        {
          text: "Machinery",
          link: "pms/machinery-norms",
        },
      ],
    },
    {
      text: "Calendar",
      link: "pms/calendar",
    },
  ],
  projectNav: [
    // Dashboard & Overview
    {
      text: "Dashboard & Overview",
      subMenu: [
        {
          text: "Dashboard",
          link: "pms/project/dashboard",
        },
        {
          text: "View",
          link: "pms/project/view",
        },
      ],
    },
    // Planning & Execution
    {
      text: "Planning & Execution",
      subMenu: [
        {
          text: "WBS",
          link: "pms/project/wbs",
        },
        {
          text: "Phases",
          link: "pms/project/phases",
        },
        {
          text: "Activities",
          link: "pms/project/activities",
        },
        {
          text: "Tasks",
          link: "pms/project/tasks",
        },
        {
          text: "Issues",
          link: "pms/project/issues",
        },
        {
          text: "Daily Approvals",
          link: "pms/project/daily-approvals",
        },
      ],
    },
    // Collaboration & Documentation
    {
      text: "Collaboration & Documentation",
      subMenu: [
        {
          text: "Documents",
          link: "pms/project/documents",
        },
        {
          text: "Project Users",
          link: "pms/project/project-users",
        },
      ],
    },
    // Time & Resource Management
    {
      text: "Time & Resource Management",
      subMenu: [
        {
          text: "Timesheet",
          link: "pms/project/timesheet",
        },
        {
          text: "Time Log Settings",
          link: "pms/project/time-log-settings",
        },
        {
          text: "Sequence",
          link: "pms/sequence/SequenceList",
        },
      ],
    },
    // Analytics & Reporting
    {
      text: "Analytics & Reporting",
      subMenu: [
        {
          text: "Reports",
          link: "pms/project/reports",
        },
        {
          text: "Inventory Analysis",
          link: "pms/project/inventory-analysis",
        },
        {
          text: "Budget Analysis",
          link: "pms/project/budget-analysis",
        },
        {
          text: "3M Consolidation",
          link: "pms/project/3m-consolidation",
        },
        {
          text: "Expenses",
          link: "pms/expenses/reports",
        },
      ],
    },
    // exports & imports
    {
      text: "Imports & Exports",
      subMenu: [
        {
          text: "Imports",
          link: "pms/bulk-upload-list",
        },
        {
          text: "Exports",
          link: "pms/excelexport-requested-list"
        },
      ]
    }
  ],
};

export default TopMenu;
